// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { text } from '../../tokens/themeColors/text';
// Paper has no direct Figma "Paper/*" component-color prefix, so it aliases
// Background Colors/Template/Paper directly (a Theme Colors token) rather
// than Card's Component Colors card — Card/Default/Background aliases
// Background Colors/Level 0, which matches Paper in light mode but diverges
// in dark mode (level0 -> grey[950] vs template.paper -> grey[850]).
// Border/text have no Template equivalent, so they stay cross-referenced
// from Card's base surface (excluding Card-specific extras like Secondary Text).
export var paperColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var tx = text(mode);
    return {
        background: bg.template.paper,
        border: bd.default,
        text: tx.primary
    };
};

//# sourceMappingURL=paperColors.js.map